export default __webpack_public_path__ + "static/media/security.70250d65.png";